module.exports = __webpack_public_path__ + "img/LC.3995dda7.svg";